import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import AvatarInstance from "../../AVATAR/AvatarInstance";
import LOG, { log } from "../../../UTIL/LOG";
import Cue from "../../../UTIL/Instances/Cue";
import AVATAR from "../../../Core/USER/AVATAR/AVATAR";
import ARRAY from "../../../UTIL/ARRAY";
import GameInstance from "../GameInstance";

class Players 
{
  private gameInstance    : GameInstance;
  private conquer         : CONQUER;
  public currentAvatarID  : any;
  public current          : number = 0;
  public items            : any;
 
  public constructor( gameInstance : GameInstance ) 
  {
    this.gameInstance   = gameInstance;
    this.conquer        = gameInstance.conquer;
    
  }
 
  /*=============== 


  GET


  ================*/

  public get( amount : number = 1 )
  {
    if( this.items ) return this.items;
 
    this.items            = [ this.conquer.Avatars.ME ];
    this.items            = ARRAY.shuffle( ARRAY.push( this.gameInstance.Rivals.get( amount-1 ), this.items ) );
    this.current          = -1;
    this.currentAvatarID  = null;
 
    return this.items;
  }

  /*=============== 


  NEXT


  ================*/

  public next()
  {
    if( !this.items ) this.get();

    if( ++this.current >= this.items.length ) this.current = 0;

    let Avatar = this.items[ this.current ];

    this.currentAvatarID = Avatar.avatarID;

    this.gameInstance.Signal.set( "PLAYERS:onNext", Avatar );

    return Avatar;
  }

  /*=============== 


  GET


  ================*/

  public set( player : any )
  {
   
  }
  

  /*=============== 


  REMOVE
 

  ================*/

  public remove()
  {
    
  }

  public reset()
  {
      this.items = null;
  }

 
}

export default Players;
